module.exports = __webpack_public_path__ + "img/IMG-20191016-WA0002.06c4ab68.jpg";